/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type TotalTenantsStatQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TotalTenantsStatQuery = { __typename: 'Query', clients?: { __typename: 'ClientTypeConnection', totalCount?: number | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const TotalTenantsStatDocument = new TypedDocumentString(`
    query TotalTenantsStat {
  clients {
    totalCount
  }
}
    `);

export const useTotalTenantsStatQuery = <
      TData = TotalTenantsStatQuery,
      TError = unknown
    >(
      variables?: TotalTenantsStatQueryVariables,
      options?: Omit<UseQueryOptions<TotalTenantsStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TotalTenantsStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TotalTenantsStatQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['TotalTenantsStat'] : ['TotalTenantsStat', variables],
    queryFn: fetcher<TotalTenantsStatQuery, TotalTenantsStatQueryVariables>(TotalTenantsStatDocument, variables),
    ...options
  }
    )};

useTotalTenantsStatQuery.getKey = (variables?: TotalTenantsStatQueryVariables) => variables === undefined ? ['TotalTenantsStat'] : ['TotalTenantsStat', variables];

export const useInfiniteTotalTenantsStatQuery = <
      TData = InfiniteData<TotalTenantsStatQuery>,
      TError = unknown
    >(
      variables: TotalTenantsStatQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TotalTenantsStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TotalTenantsStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<TotalTenantsStatQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['TotalTenantsStat.infinite'] : ['TotalTenantsStat.infinite', variables],
      queryFn: (metaData) => fetcher<TotalTenantsStatQuery, TotalTenantsStatQueryVariables>(TotalTenantsStatDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteTotalTenantsStatQuery.getKey = (variables?: TotalTenantsStatQueryVariables) => variables === undefined ? ['TotalTenantsStat.infinite'] : ['TotalTenantsStat.infinite', variables];


useTotalTenantsStatQuery.fetcher = (variables?: TotalTenantsStatQueryVariables) => fetcher<TotalTenantsStatQuery, TotalTenantsStatQueryVariables>(TotalTenantsStatDocument, variables);
